module.exports = __webpack_public_path__ + "img/setnumber.958fdbb9.svg";